import moment from "moment";
import { ScoringCardsClient } from "@topline/services/apiService";
import { AgGridService } from "@topline/services/agGridService";
import { DateService } from "@topline/services/dateService";
import { MarketEditService } from "./services/marketEditService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ProjectDataService } from "./services/projectDataService";

(function (module) {
    "use strict";
    module.controller("marketScoringCardsEditCtrl", [
        "market",
        "editable",
        "projects",
        MarketEditService.componentName,
        ScoringCardsClient.componentName,
        ProjectDataService.componentName,
        AgGridService.componentName,
        "$state",
        "$scope",
        angularServicesNames.$translate,
        "AlertService",
        "modalService",
        DateService.componentName,
        "$timeout",
        marketScoringCardsEditCtrl
    ]);

    function marketScoringCardsEditCtrl(
        this: $TSFixMe,
        market: $TSFixMe,
        editable: $TSFixMe,
        projects: $TSFixMe,
        marketEditService: MarketEditService,
        apiClient: ScoringCardsClient,
        projectDataService: ProjectDataService,
        agGridService: AgGridService,
        $state: ng.ui.IStateService,
        $scope: $TSFixMe,
        $translate: ng.translate.ITranslateService,
        AlertService: AlertService,
        modalService: $TSFixMe,
        dateService: DateService,
        $timeout: ng.ITimeoutService
    ) {
        var $ctrl = this;

        $ctrl.market = market;
        $ctrl.projects = projects;
        $ctrl.canEdit = editable.isEditable == 1;
        $ctrl.canClone = editable.isCloneable == 1;
        $ctrl.readOnly = !$ctrl.canEdit;
        $ctrl.priceChangeStartDate = new Date(dateService.getDefaultBudgetYear(), 0, 1);

        if (!angular.isUndefinedOrNull(angular._get(market, "project.uId"))) {
            $timeout(() => {
                $ctrl.marketServerOperation = projectDataService
                    .getProjectData($ctrl.market.project.uId)
                    .then((data: $TSFixMe) => {
                        $ctrl.gridApi.setRowData(data.skus);
                    });
            });
        }

        if (!$ctrl.canEdit && $ctrl.market.isCreatedByMy && $ctrl.canClone) {
            AlertService.warning($translate.instant("MARKET.READONLY_MODE"));
        }

        if ($ctrl.canEdit && $ctrl.market && $ctrl.market.budgetYear == null) {
            $ctrl.market.budgetYear = dateService.getDefaultBudgetYear();
        }

        $ctrl.projectChanged = (oldValue: $TSFixMe) => {
            if (!angular.isUndefinedOrNull(oldValue) && !confirm($translate.instant("MARKET.PROJECT_CONFIG_CHANGE"))) {
                $ctrl.market.project = oldValue;
                return;
            }
            $ctrl.market.name = $ctrl.market.project.name;

            $ctrl.marketServerOperation = projectDataService.getProjectData($ctrl.market.project.uId).then(data => {
                var startYear = dateService.getDefaultBudgetYear();
                var endYear = parseInt(moment(data.forecastEndDate).format("YYYY"));

                $ctrl.priceChangeStartDate = new Date(startYear, 0, 1);

                $ctrl.projectYearlyData = data.projectForecast;
                $ctrl.market.forecastStartDate = data.forecastStartDate;
                $ctrl.market.forecastEndDate = data.forecastEndDate;
                $ctrl.market.yearlyAveragePrice = data.projectForecast.filter(
                    (x: $TSFixMe) => x.averagePrice && x.year < startYear
                );

                $ctrl.market.priceChangeInYears = _.times(endYear - startYear + 1, _.constant(0));
                $ctrl.market.marketForecast = null;
                $ctrl.gridApi.setRowData(data.skus);
            });
        };

        $ctrl.save = () => {
            $ctrl.marketServerOperation = marketEditService
                .saveScoringCardsMarket($ctrl.market)
                .then(() => $state.go("market.list"));
        };

        $scope.removeMarket = function () {
            if (!$ctrl.canEdit) {
                AlertService.warning($translate.instant("MARKET.READONLY_MODE"));
                return;
            }

            modalService.showConfirmationModal(
                {
                    text: "MARKET.REMOVE_CONFIRM",
                    title: "MARKET.REMOVE_CONFIRM_TITLE"
                },
                () => {
                    marketEditService
                        .delete($ctrl.market.id)
                        .then(function () {
                            $state.go("market.list");
                            AlertService.success($translate.instant("MARKET.REMOVE_SUCCESS"));
                        })
                        .catch(function () {
                            AlertService.error($translate.instant("MARKET.REMOVE_ERROR"));
                        });
                },
                null,
                "danger"
            );
        };

        $scope.$on("LanguageChanged", () => agGridService.refreshGridLanguage($ctrl.gridApi));

        $ctrl.skuGridOptions = {
            columnDefs: [
                {
                    headerValueGetter: () => $translate.instant("MARKET.SC_GRID.PROJECT_CODE"),
                    field: "projectCode",
                    filter: "agTextColumnFilter",
                    filterParams: { newRowsAction: "keep" }
                },
                {
                    headerValueGetter: () => $translate.instant("MARKET.SC_GRID.NAME"),
                    field: "name",
                    filter: "agTextColumnFilter",
                    filterParams: { newRowsAction: "keep" }
                }
            ],
            angularCompileRows: true,
            animateRows: true,
            defaultColDef: {
                sortable: true,
                resizable: true
            },
            floatingFilter: true,
            suppressMultiSort: true,
            domLayout: "autoHeight",
            pagination: true,
            paginationPageSize: 10,
            localeTextFunc: agGridService.transalteFunc,
            suppressHorizontalScroll: true,
            onGridReady: (config: $TSFixMe) => {
                $ctrl.gridApi = config.api;
                config.api.sizeColumnsToFit();
            },
            onGridSizeChanged: (config: $TSFixMe) => {
                config.api.sizeColumnsToFit();
            }
        };
    }
})(angular.module("topline.chamferForecast"));
